<template>
    <div>
        <PersonageInfo class="pc"></PersonageInfo>
        <XPersonInfo class="mobile"></XPersonInfo>
    </div>
</template>

<script>
import PersonageInfo from '@/pages/personageInfo/PersonageInfo.vue'
import XPersonInfo from '@/pages/xPersonInfo/XPersonInfo.vue'

export default {
  name: 'app',
  components: {  
    PersonageInfo:PersonageInfo,
    XPersonInfo:XPersonInfo,
  }
}
</script>